import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import i18n from "./i18n/i18n";
import VueSweetalert2 from "vue-sweetalert2";
import vSelect from "vue-select";
import Multiselect from "vue-multiselect";
import { Datetime } from "vue-datetime";
import moment from "moment";
import "vue-datetime/dist/vue-datetime.css";
import VueEvents from "vue-events";
var VueTouchKeyboard = require("vue-touch-keyboard");

// import Multiselect from 'vue-multiselect'

// You need a specific loader for CSS files

import VueHtmlToPaper from "vue-html-to-paper";

// or, using the defaults with no stylesheet
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://unpkg.com/vue-material/dist/vue-material.min.css",
    "https://unpkg.com/vue-material/dist/theme/default.css",
    "./assets/scss/material-dashboard.scss",
    "./assets/css/demo.css",
    "./assets/css/pr.css",
  ],
};

Vue.use(VueHtmlToPaper, options);

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

Vue.use(LightBootstrap);

// import 'bootstrap/dist/css/bootstrap.css';
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-datetime/dist/vue-datetime.css";
import spinner from "./components/spinner.vue";
import noData from "./components/no-data.vue";
// Css related to vue-select
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
// Vivo restyle override — MUST be the last CSS import so it wins the cascade.
import "./assets/css/vivo-theme.css";
// Vivo screen components (mockup design system, scoped under `.vivo`).
import "./assets/css/vivo-components.css";
import "./assets/css/vivo-shell.css";

import { HelperMethods } from "./helper";

Vue.config.productionTip = false;
Vue.use(VueSweetalert2);
Vue.use(VueEvents);
Vue.use(VueTouchKeyboard);

Vue.component("v-select", vSelect);
Vue.component("multiselect", Multiselect);
Vue.component("datetime", Datetime);
Vue.component("spinner", spinner);
Vue.component("no-data", noData);

HelperMethods(Vue.prototype);

Vue.filter("formatDate", (value: any) => {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
}),
  Vue.filter("gethours", (value: any) => {
    if (value) {
      return moment(String(value)).format("hh:mm A");
    }
  }),
  // Vue.component("my-component", {
  //   components: {
  //     VueMonthlyPicker,
  //   },
  // });

  (Vue.config.silent = true);

Vue.directive("permission", {
  bind(el, binding, vnode) {
    let user: any = null;
    try {
      user = JSON.parse(localStorage.getItem("user") || "null");
    } catch (e) {
      user = null;
    }
    const roles: string[] = (user && user.roles) || [];
    if (user && !user.allRoles && roles.indexOf(binding.value) === -1) {
      el.style.display = "none";
    }
  },
});

Vue.prototype.$eventHub = new Vue();
import VueSocketIOExt from "vue-socket.io-extended";
import io from "socket.io-client";

// Legacy booking realtime channel. Only connect when a socket origin is
// configured (dev/booking via VUE_APP_SOCKET_URL); the §4 integration build
// leaves it unset so the HR portal doesn't spam console errors dialing a
// booking server that isn't part of the integration stack.
const socketUrl = process.env.VUE_APP_SOCKET_URL || "";
if (socketUrl) {
  const socket = io(socketUrl);
  Vue.use(VueSocketIOExt, socket, { store });
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
